<template>
    <div id="app-vue-spreadsheet" :style="appVueSpreadSheet" class="bts-window-form">
        <div class="toolbar-container">
            <template v-if="processing || isAnyRowLoading">
                <mdb-btn color="elegant" size="sm" disabled class="btn btn-sm btn-elegant">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Please wait...
                </mdb-btn>
            </template>
            <template v-else>
                <mdb-dropdown class="m-1">
                    <mdb-dropdown-toggle slot="toggle" color="elegant" size="sm">Generate Labels</mdb-dropdown-toggle>
                    <mdb-dropdown-menu >
                    <a class="dropdown-item" href="javascript:void(0)" @click="childClick('15x10-wh')">15x10CM - WH PRODUCT LABEL</a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="childClick('39x58-wh')">3.9x5.8CM - WH PRODUCT LABEL</a>
                    </mdb-dropdown-menu>
                </mdb-dropdown>


                <mdb-btn color="elegant" size="sm" @click="fnLoadManifestData" :disabled="processing" class="btn btn-sm btn-elegant ml-0">
                    Load Manifest
                </mdb-btn>

                <div class="d-inline-flex p-1">
                    <el-radio-group v-model="connection" class="border border-info p-2 rounded">
                    <el-radio label="QATL_PRODUCTION" class="mb-0">QATL_PRODUCTION</el-radio>
                    <template v-if="checkSystemSupport">
                        <el-radio label="QATL_DEV" class="mb-0">QATL_DEV</el-radio>
                    </template>
                    </el-radio-group>
                </div>
            </template>
        </div>
        
        <div ref="spreadsheet"></div>

        <GetManifestModal ref="getManifestModal" @success="fnSuccess" @error="fnError"/>
    </div>
</template>

<script>

import jspreadsheet from '../../jsexcel/jexcel'
import GetManifestModal from './GetManifestModal.vue'
import {mapActions} from 'vuex'
import { mdbBtn, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu } from 'mdbvue';
import { userData } from '../../helpers/user'
export default {
    components : {
        mdbBtn,
        mdbDropdown,
        mdbDropdownToggle,
        mdbDropdownMenu,
        GetManifestModal
    },
    data() {

        const self = this;

        const worksheetColumns = [
                    {
                        type: 'text',
                        width: '250px',
                        title: 'MANIFEST NO.',
                        align: 'left',
                        name: 'manifest_no',
                        readOnly: true,
                        primaryKey: true
                    },
                    {
                        type: 'text',
                        width: '250px',
                        title: 'ITEM CODE',
                        align: 'left',
                        name: 'series',
                        readOnly: true,
                        primaryKey: true
                    },
                    {
                        type: 'text',
                        width: '150px',
                        title: 'UOM',
                        align: 'left',
                        name: 'uom_text',
                        readOnly: true,
                        primaryKey: false
                    },
                    {
                        type: 'text',
                        width: '250px',
                        title: 'UPC CODE',
                        align: 'left',
                        name: 'upc_code',
                        readOnly: false,
                        primaryKey: false
                    },
                    {
                        type:'calendar',
                        width: '150px',
                        title: 'BATCH NO.',
                        align: 'left',
                        name: 'batch_number',
                        readOnly: false,
                        primaryKey: false,
                        options: { format:'YYYY-MM-DD' },
                    },
                    {
                        type: 'number',
                        width: '100px',
                        title: 'QUANTITY',
                        align: 'center',
                        name: 'qty',
                        readOnly: false,
                        primaryKey: false
                    },
                    {
                        type: 'hidden',
                        name: 'uom',
                    }

                ];
        return {
            connection : "QATL_PRODUCTION",
            isSave : false,
            appVueSpreadSheet : {
                width : 'calc(100vw - 240px)',
                height: 'calc(100vh - 45.43px)!important'
            },
            width : 1300,
            height : 1024,
            dialogIsOpen : false,
            spreadsheet: null,
            processing: false,
            exporData : [],
            exporDataSaving : false,
            generated_serial : "",
            showAlert: true,
            formData : null,
            rowLoading: {},
            alertMessage: "This print barcode is only for existing items.",
            alertColor: "info",
            options : {
                tableOverflow: true,
                tableWidth: "400px",
                tableHeight: "400px",
                wordWrap : true,
                allowDeleteColumn : false,
                allowRenameColumn : false,
                data:[[]],
                minDimensions:[1,30],
                columns: worksheetColumns        
            },
            worksheetColumns : worksheetColumns,
            exportTableOptions : {
                download : true,
                csvFileName : 'serial-number',
                allowDeleteColumn : false,
                allowRenameColumn : false,
                allowInsertColumn : false,
                csvHeader:true,
                tableWidth : 'calc(100vw - 255px)',
                tableHeight : 'calc(100vh - 140px)',
                tableOverflow : true,
                data:[[]],
                minDimensions:[1,30],
                onCopy : null,
                selectionCopy : false,
                allowCopy : true,
                columns: worksheetColumns,
                onchange: function(domElement, domElmentCell, column, row, value,oldValue){
                    if(column == 1){
                        
                        if((value != null && value != '' && value != oldValue) || (oldValue == '' && oldValue == null)){
                            console.log("onChange")
                            console.log(value,row)
                            self.fnGetItem(value,row)
                        }
                    }
                },
            },
            user : null,
            unit_of_measurements : [],
        }
    },

    provide() {
        return {
            connection : () => this.connection
        }
    },

    mounted() {
        const self = this;
        this.height = window.innerHeight;
        if(this.spreadsheet !== null){
            this.spreadsheet.destroy();
            this.createPopupTable(this.exportTableOptions)
        }else{
            this.createPopupTable(this.exportTableOptions)
        }
        this.setUser()
    },

    methods : {
        ...mapActions("UpcGeneratorModule", ["checkRecord"]),
        ...mapActions('SapItemMasterModule',['getRecord']),
        ...mapActions('ItemModule',['fetchSap']),
        ...mapActions('PrintDatamatrixModule',['storeRecord']),
        ...mapActions('UnitOfMeasurementModule',['getUnitOfMeasurementGroups']),
        async fnLoadManifestData(){
            if(this.processing === false){
                this.$refs.getManifestModal.openDialog();
            }
        },

        async setUser(){
            this.user = await userData()
        },

        fnSuccess(response){
            if(response.length > 0){
                const finalData = response.map((item) => {
                    return {
                        manifest_no : item.ManifestNumber,
                        series : item.ItemCode,
                        uom_text : item.UOM,
                        uom : item.UoMEntry,
                        upc_code : item.Barcode,
                        batch_number : item.BatchNumber,
                        qty : parseFloat(item.Quantity),
                    }
                })
                this.spreadsheet.setData(finalData)
                this.$ThatsNotify.success({message : 'Data loaded successfully', type : 'success'})
            }else{
                this.$ThatsNotify.error({message : 'No data found', type : 'error'})   
            }
        },
        fnError(error){
            console.log("error")
            console.log(error)
            this.$ThatsNotify.error({message : 'No data found', type : 'error'})
        },
       async childClick(size){
            
            if(this.processing === false){
                this.exporDataSaving = false;
                
                const tableData = this.spreadsheet.getJson();
 
                if(tableData.length > 0){

                    console.log(tableData)
                    
                    const filterData = tableData.filter(function(rowElement){
                        return (rowElement.series != "");
                    },[])

                    if(filterData.length == 0){
                        this.$ThatsNotify.error({message : 'Please select at least one item', type : 'error'})
                        return false;
                    }

                    if(this.formData !== null && this.formData.id !== null){
                        this.onSubmitPrint(size)
                        return false;
                    }

                    console.log("filterData")
                    console.log(filterData)

                    if(filterData.length > 0){      
                        
                        const checkUpcCode = filterData.filter(function(rowElement){
                            return (rowElement.upc_code != "") ;
                        },[])

                        const checkUpcCodeLength = filterData.filter(function(rowElement){
                            return (rowElement.upc_code.length == 14);
                        },[])
                        
                        const checkBatch = filterData.filter(function(rowElement){
                            return (rowElement.batch_number != "");
                        },[])

                        const checkQuantity = filterData.filter(function(rowElement){
                            return (rowElement.qty != "" && rowElement.qty != 0);
                        },[])

                        console.log(`upc : ${checkUpcCode.length}, upc length : ${checkUpcCodeLength.length}, batch : ${checkBatch.length}, quantity : ${checkQuantity.length}`)

                        if(checkUpcCode.length != filterData.length){
                            this.$ThatsNotify.error({message : 'Please fill up all upc code', type : 'error'})
                            return false;
                        }

                        if(checkUpcCodeLength.length != filterData.length){
                            this.$ThatsNotify.error({message : 'Please enter valid upc code', type : 'error'})
                            return false;
                        }

                        if(checkBatch.length != filterData.length){
                            this.$ThatsNotify.error({message : 'Please fill up all batch', type : 'error'})
                            return false;
                        }
                        
                        if(checkQuantity.length != filterData.length){
                            this.$ThatsNotify.error({message : 'Please fill up all quantity', type : 'error'})
                            return false;
                        }

                        this.processing = true;
                        this.storeRecord({items : filterData}).then(response => {
                                    console.log("response");
                                    console.log(response.data)
                                    this.processing = false;
                                    this.formData = response.data;
                                    this.onSubmitPrint(size)
                                }).catch(error => {
                                    console.log("error");
                                    console.log(error);
                                    this.processing = false;
                                    this.formData = null;
                                });

                    }
                }
    
                
            }

        },

        onSubmitPrint(size){
            const self = this;

            if(self.formData !== null && self.formData.id !== null){
                var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";

                const win = window.open(`/barcode/print-data-matrix/${self.formData.id}?size=${size}`, "_blank", strWindowFeatures);
                    win.document.title = 'Print';
                    win.print()
            }
        },


        async createPopupTable(exportTableOptions){
            const self = this;
            if(self.spreadsheet !== null){
                await self.spreadsheet.destroy();
            }
            this.spreadsheet = jspreadsheet(this.$refs.spreadsheet, exportTableOptions);
            Object.assign(this, this.spreadsheet);
            this.spreadsheet.setWidth(window.innerWidth)
        },

        async recreateSpreadsheet(){
            const self = this;
            if(self.spreadsheet !== null){
                await self.spreadsheet.destroy();
                self.createPopupTable(self.exportTableOptions)
            }
        },


        async fnGetItem(itemCode, index){

            const self = this;
            const parseIntIndex = parseInt(index)
          
            await this.checkRecord({item : itemCode, index : parseIntIndex, connection : self.computedConnection}).then((response)=> {
            const {data : res} = response
                self.spreadsheet.setValueFromCoords(2,parseIntIndex,res.UomCode,true)

                if(res.Barcode != null && res.Barcode !== ""){
                self.spreadsheet.setValueFromCoords(3,parseIntIndex,res.Barcode,true)
                }
                self.spreadsheet.setValueFromCoords(5,parseIntIndex,res.UgpEntry,true)
                self.spreadsheet.setValueFromCoords(6,parseIntIndex,res.ItemBarCodeCollection,true)
            }).catch(() => {
  
                self.spreadsheet.setValueFromCoords(1,parseIntIndex,"",true)
                self.spreadsheet.setValueFromCoords(2,parseIntIndex,"",true)
                self.spreadsheet.setValueFromCoords(3,parseIntIndex,"",true)
              
            })

            /* const self = this;
            console.log("beforeFetchSap")
            console.log(itemCode,index)
            self.$set(self.rowLoading, index, true);
            self.formData = null;
            await self.getRecord({item : itemCode, index : index, connection : self.computedConnection}).then((res)=> {
                const row = parseInt((index + 1))
                console.log("afterFetchSap")
                console.log(res)

                const filteredBarcode = res.ItemBarCodeCollection.filter((item) => {
                    return item.UoMEntry == res.DefaultPurchasingUoMEntry;
                })

                if(filteredBarcode.length > 0){
                    const barcode = filteredBarcode[0];
                    if(barcode){
                        self.spreadsheet.setValueFromCoords(2,index,barcode.UoMEntry,true)
                        self.spreadsheet.setValueFromCoords(3,index,barcode.Barcode,true)
                        
                    }
                    self.spreadsheet.setValueFromCoords(5,index,1,true)
                }
                self.$set(self.rowLoading, index, false);
            }).catch((error) => {
                console.log("catch")
                console.log(error)
                self.$set(self.rowLoading, index, false);
            }) */
        },
    },
    computed: {
        isAnyRowLoading() {
            return Object.values(this.rowLoading).some((v) => v);
        },
        computedConnection() {
            return this.connection;
        },
        checkSystemSupport : function(){
          return this.$helpers.isSystemAdministrator() || [424].includes(this.user?.user?.id);
      },
    },

    watch : {

        dialogIsOpen : function(v){
            if(v === false){
                this.spreadsheet.destroy();
            }else{
                this.createPopupTable(this.exportTableOptions)                 
            }
        },
        unit_of_measurements : function(v){
            this.exportTableOptions.columns = [
                    {
                        type: 'text',
                        width: '250px',
                        title: 'MANIFEST NO.',
                        align: 'left',
                        name: 'manifest_no',
                        readOnly: true,
                        primaryKey: true
                    },
                    {
                        type: 'text',
                        width: '250px',
                        title: 'ITEM CODE',
                        align: 'left',
                        name: 'series',
                        readOnly: false,
                        primaryKey: true
                    },
                    {
                        type: 'dropdown',
                        width: '150px',
                        title: 'UOM',
                        align: 'left',
                        name: 'uom_text',
                        readOnly: false,
                        primaryKey: false,
                        source : self.unit_of_measurements,
                        autocomplete :true,
                        multiple :false
                    },
                    {
                        type: 'text',
                        width: '250px',
                        title: 'UPC CODE',
                        align: 'left',
                        name: 'upc_code',
                        readOnly: false,
                        primaryKey: false
                    },
                    {
                        type:'calendar',
                        width: '150px',
                        title: 'BATCH NO.',
                        align: 'left',
                        name: 'batch_number',
                        readOnly: false,
                        primaryKey: false,
                        options: { format:'YYYY-MM-DD' },
                    },
                    {
                        type: 'number',
                        width: '100px',
                        title: 'QUANTITY',
                        align: 'center',
                        name: 'qty',
                        readOnly: false,
                        primaryKey: false
                    },
                    {
                        type: 'hidden',
                        name: 'uom',
                    }

                ];
            this.createPopupTable(this.exportTableOptions)
        }
    }

}
</script>